export const templates = {
    BorrowerSurveyInitiated: "BorrowerSurveyInitiated",
    AssistanceOption: "AssistanceOption",
    RuleEngineDisclosure: "RuleEngineDisclosure",
    WorkoutOptionDeclined: "WorkoutOptionDeclined",
    CurrentBorrowerSurveyInitiated: "CurrentBorrowerSurveyInitiated"
}